//#region Libraries
import { useNavigate } from "react-router-dom";
//#endregion
//#region Styles
import { LinkA } from "components/styles";
import { 
    Container,
    ActionsCell, 
    NameCell, 
    ProgrammingCell, 
    TDef, 
    TimeCell } from "components/CustomTableList/components/TableListItem/ListItem/styles";
//#endregion
//#region Components
import CustomButton from "components/CustomButton/CustomButton";
//#endregion
//#region Icons
import EditIcon from "icons/EditIcon";
import TrashIcon from "icons/TrashIcon";
//#endregion
//#region Utils
import ABSOLUTE_PATHS from "routes/utils/absolutePaths";
//#endregion

const TDEF_CONTENT_PROPS = {
    margin: "1px 0"
};

const DateListItemOfWeek = ({
    id,
    date,
    time,
    programming,
    isToday,
    isPast,
    isTeacherUser, 
    canTakeAttendance,
    askIfItWillBeUpdated,
    askIfItWillBeDeleted,
    fillEventDataToAttendance
}) => {
    const navigate = useNavigate();
    //#region Functions
    const renderProgrammingCellContent = () => {
        const { place, zoom } = programming;
        if (place)
            return (
                <h5 title={`${place.campus} ${place.address}`}><strong>{place.campus} </strong>{place.address}</h5>
            );
        const classNameLinkA = isPast ? "disabled" : "";
        return (
            (isToday || isPast) && zoom
            ? <LinkA className={classNameLinkA} href={zoom} target="_blank" title={zoom}>{zoom}</LinkA>
            : <h5>Link de zoom se habilita antes del evento</h5>
        );
    };
    const getClassName = {
        nameCell: () => {
            const classList = ["small", "ellipsis"];
            isToday && classList.push("stand-out yes");
            isPast && classList.push("is-past");
            return classList.join(" ");
        },
        timeCell: () => {
            const classList = ["small"];
            isToday && classList.push("stand-out");
            isPast && classList.push("is-past");
            return classList.join(" ");
        },
        programmingCell: () => {
            const classList = ["small"];
            isPast && classList.push("is-past");
            return classList.join(" ");
        },
        actionsCell: () => {
            const classList = ["small"];
            return classList.join(" ");
        }
    };
    const propsAdminActionsCell = {
        className: getClassName.actionsCell(),
        minWidth: "100px"
    };
    const updateDialog = () => {
        askIfItWillBeUpdated({
            id, date, 
            time
        });
    }
    const deleteDialog = () => {
        askIfItWillBeDeleted({
            id, date, 
            time
        });
    }
    const goToAttendaceView = () => {
        if (!canTakeAttendance) return;
        fillEventDataToAttendance({
            dateEventId: id
        });
        navigate(ABSOLUTE_PATHS.ATTENDANCE_EVENT);
    }
    //#endregion
    return (
        <Container>
            <TDef>
                <NameCell 
                    {...TDEF_CONTENT_PROPS} 
                    className={getClassName.nameCell()}>
                    <h5 title={date.formatted}>{date.formatted}</h5>
                </NameCell>
            </TDef>
            <TDef>
                <TimeCell 
                    {...TDEF_CONTENT_PROPS} 
                    className={getClassName.timeCell()}>
                    <h5 title={time.formatted}>{time.formatted}</h5>
                </TimeCell>
            </TDef>
            <TDef>
                <ProgrammingCell 
                    {...TDEF_CONTENT_PROPS} 
                    className={getClassName.programmingCell()}>
                    {renderProgrammingCellContent()}
                </ProgrammingCell>
            </TDef>
            {isTeacherUser 
            ? <TDef>
                <ActionsCell 
                    {...TDEF_CONTENT_PROPS} 
                    className={getClassName.actionsCell()}>
                    <CustomButton 
                        text="Tomar asistencia"
                        size="small"
                        width="125px"
                        height="35px"
                        disabled={!canTakeAttendance}
                        onClick={goToAttendaceView}/>
                </ActionsCell>
            </TDef>
            : <>
            <TDef>
                <ActionsCell 
                    {...TDEF_CONTENT_PROPS} 
                    {...propsAdminActionsCell}>
                    <CustomButton 
                        variant="terciary" 
                        icon={<EditIcon/>}
                        size="small"
                        width="40px"
                        disabled={isPast}
                        onClick={updateDialog}/>
                </ActionsCell>
            </TDef>
            <TDef>
                <ActionsCell 
                    {...TDEF_CONTENT_PROPS} 
                    {...propsAdminActionsCell}>
                    <CustomButton 
                        variant="terciary" 
                        icon={<TrashIcon/>}
                        size="small"
                        width="40px"
                        disabled={isPast}
                        onClick={deleteDialog}/>
                </ActionsCell>
            </TDef>
            </>}
        </Container>
    );
}

export default DateListItemOfWeek;